$(function () {
  window.slider = window.slider || [];

  $('.siblings').each(function (i,e,a) {
    window.slider[i] = new Swiper(this,{
      speed: 500,
      autoplay: 8500,
      autoplayDisableOnInteraction: false,
      simulateTouch: false,
      slidesPerView: 6,
      breakpoints: {
        576: {
          slidesPerView: 2
        },
        768: {
          slidesPerView: 4
        },
        992: {
          slidesPerView: 5
        }
      },
      loop: false,
      centeredSlides: false,
      prevButton: $(this).find('.swiper-button-prev')[0],
      nextButton: $(this).find('.swiper-button-next')[0]
    })

    var _this = $(this);
    square(_this.find('.partner-square'));
    $(window).on('resize',function () {
      square(_this.find('.partner-square'));
    })
  })
})
